<template>
<div class="large-container">
	<div class="title">人员详情</div>
	<Form :label-width="110" class="mt30">
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="姓名">
					<Input v-model="params.insurerName" clearable @on-enter="search" placeholder="请输入姓名"></Input>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10" >
			<Col span="12" class="left" v-if="policyStatusCode!='INVALID'">
				<Button type="primary" @click="addClick">加人</Button>
				<Button type="primary" :disabled="selectedList.length==0" @click="deleteClick">批量删除</Button>
				<Button type="primary" @click="replaceClick">批量替换</Button>
			</Col>
			<Col :span="policyStatusCode!='INVALID'?12:24" class="right">
				<Button type="info" @click="search">搜索</Button>
			</Col>
		</Row>
	</Form>
	<i-table class="mt10" :columns="columns" url="/employment/person/queryPolicyUser.json" :params="params" ref="table" @on-selection-change="onSelectionChange" selectType="flexible">
		<template slot-scope="{ row }" slot="action" v-if="policyStatusCode!='INVALID'">
			<a @click="toEditName(row)">编辑姓名</a>
			<a @click="toEdit(row)" class="ml10">替换</a>
		</template>
	</i-table>
	<Modal
		v-model="addShow"
		title="加人"
        width="800px"
        :mask-closable="false">
		<Form :model="addForm" ref="addForm" :label-width="125" :rules="addFormRules">
			<FormItem label="员工保障起期：" prop="policyBegin">
				<DatePicker 
					v-model="addForm.policyBegin" 
					type="date" 
					placeholder="请选择员工保障起期" 
					style="width: 300px" 
					@on-change="getPrice"
					:options="dateOptions">
				</DatePicker>
			</FormItem>
		    <FormItem label="员工保障止期：" required>
		        {{addForm.policyEnd}}
		    </FormItem>
			<FormItem label="人员新增模板：">
				<a @click="exportToExcel('/employment/policy/downloadPersonTemplate')" target="__blank">下载模板</a>
		    </FormItem>
			<FormItem label="上传清单：" prop="personItemList">
				<UploadFile	
				ref="upload"
				style="display:inline-block"
				url="/pc/employment/policy/importPerson"
				btn-text="上传"
				:show-upload-list="true"
				:data="UploadForm"
				@on-remove= "removeList"
				@on-success="uploadSuccess" />
		    </FormItem>
			<FormItem label="合计保费：">
				{{addForm.policyFee}}
		    </FormItem>
			<FormItem label="校验结果：" v-if="!isPass">
				<Table 
					:columns="personListColumns" 
					:data="addForm.personItemList"
					class="mt10"
					border
					disabled-hover>
					<template slot-scope="{ row }" slot="checkMsg">
						<span class="red">{{row.checkMsg}}</span>
					</template>
				</Table>
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="addCancel">取消</Button>
			<Button type="primary" :disabled="!isPass" @click="confirmAdd" >提交</Button>
		</template>
	</Modal>
	<Modal
		v-model="editShow"
		title="替换"
        :mask-closable="false">
		<Form :model="editForm" ref="editForm" :label-width="110">
			<p>被替换人员</p>
			<FormItem label="身份证号：">
				{{editForm.refInsurerIdNumber}}
			</FormItem>
			<FormItem label="姓名：">
				{{editForm.refInsurerName}}
			</FormItem>
			<p>替换人员</p>
			<FormItem label="姓名：" prop="insurerName" :rules="[{ required: true, message: '姓名不能为空', trigger: 'blur' }]">
				<Input v-model.trim="editForm.insurerName" clearable placeholder="请输入姓名" :maxlength="50"></Input>
		    </FormItem>
			<FormItem label="身份证号：" :rules="[{ required: true, message: '身份证号不能为空', trigger: 'blur' },{pattern:rules.idcard,trigger:'blur',message:'身份证号格式错误'}]" prop="insurerIdNumber">
				<Input v-model.trim="editForm.insurerIdNumber" clearable placeholder="请输入身份证号"></Input>
			</FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="editCancel">取消</Button>
			<Button type="primary" @click="editconfirm" >提交</Button>
		</template>
	</Modal>
	<Modal
		v-model="replaceShow"
		title="批量替换"
        width="800px"
        :mask-closable="false">
		<Form :model="replaceForm" ref="replaceForm" :label-width="125" :rules="replaceFormRules">
			<FormItem label="人员替换模板：">
				<a @click="exportToExcel('/employment/policy/downloadReplacePersonTemplate')" target="__blank">下载模板</a>
		    </FormItem>
			<FormItem label="上传清单：" prop="replacePersonItems">
				<UploadFile	
				ref="uploadReplace"
				style="display:inline-block"
				url="/pc/employment/policy/importReplacePerson"
				btn-text="上传"
				:show-upload-list="true"
				:data="{'policyId': $route.params.id}"
				@on-remove= "removeList"
				@on-success="uploadReplaceSuccess" />
		    </FormItem>
			<FormItem label="校验结果：" v-if="!isReplacePass">
				<Table 
					:columns="replaceColumns" 
					:data="replaceForm.replacePersonItems"
					class="mt10"
					border
					disabled-hover>
					<template slot-scope="{ row }" slot="checkMsg">
						<span class="red">{{row.checkMsg}}</span>
					</template>
				</Table>
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="replaceCancel">取消</Button>
			<Button type="primary" :disabled="!isReplacePass" @click="confirmReplace" >提交</Button>
		</template>
	</Modal>
	<Modal
		v-model="editNameShow"
		title="编辑姓名"
        :mask-closable="false">
		<Form :model="editNameForm" ref="editNameForm" :label-width="125">
			<FormItem label="姓名：">
				<Input v-model="editNameForm.insurerName" :maxlength="50" placeholder="请输入姓名" />
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="editNameCancel">取消</Button>
			<Button type="primary" :disabled="!editNameForm.insurerName" @click="confirmeEitName" >提交</Button>
		</template>
	</Modal>
</div>
</template>
<script>
import ITable from '@/components/common/ITable'
import UploadFile from '../../common/UploadFileFlexible'
export default {
	components:{UploadFile,ITable},
	data () {
		return {
			policyStatusCode:this.$route.query.policyStatusCode,
			params:{
				id:this.$route.params.id,
				certificateNo: this.$route.query.certificateNo,
			},
			info:{},
			list:[],
			columns:[
				{type: 'selection',width: 60,align: 'center',fixed: 'left'},
				{title: '姓名',key: 'insurerName',width:this.$columnW.M},
				{title: '性别',key: 'insurerGender',width:this.$columnW.M},
				{title: '身份证号码',key: 'insurerIdNumber',width:this.$columnW.XL},
				{title: '保障起期',key: 'policyBegin',width:this.$columnW.L},
				{title: '保障止期',key: 'policyEnd',width:this.$columnW.L},
				{title: '保费（元）',key: 'policyFee',width:this.$columnW.M,align:'right'},
				{title: '保障状态',key: 'policyStatus',width:this.$columnW.M},
				{title: '投保公司',key: 'insuranceCompany',width:this.$columnW.XL},
				{title: '被保险公司',key: 'insurerCompany',width:this.$columnW.XL},
				{title: '用工地点（城市）',key: 'workUnit',width:this.$columnW.XL},
				{title: '保障凭证号',key: 'certificateNo',width:this.$columnW.XL},
				{title: '保单号',key: 'policyNo',width:this.$columnW.XL},
				{title: '创建时间',key: 'createTime',width:this.$columnW.XL},
				{
					title: '操作',
					slot: 'action',
					align: 'center',
					width: 160,
					fixed: 'right'
				}
			],
			selectedList:[],
			addShow:false,
			addForm:{
				personItemList:[]
			},
			addFormRules:{
				policyBegin: [
					{ required: true, type:'date', message: '请选择保障起期', trigger: 'change' }
				],
				personItemList: [
					{ required: true, type:'array', message: '请上传清单', trigger: 'change' }
				]
			},
			replaceShow:false,
			replaceForm:{},
			replaceFormRules:{
				replacePersonItems: [
					{ required: true, type:'array', message: '请上传清单', trigger: 'change' }
				]
			},
			replaceColumns:[
				{title: '校验结果',slot: 'checkMsg',width:200},
                {title: '序号',key: 'no',width:70,align:'center'},
				{title: '被替换人姓名',key: 'replacedName',width:190},
				{title: '被替换人身份证号',key: 'replacedIdNumber',minWidth:190},
                {title: '替换人姓名',key: 'replaceName',width:190},
				{title: '替换人身份证号',key: 'replaceIdNumber',width:190},
			],
			dateOptions:{},
			personListColumns:[
				{title: '校验结果',slot: 'checkMsg',width:200},
                {title: '序号',key: 'no',width:70,align:'center'},
				{title: '投保公司',key: 'insuranceCompany',width:150},
				{title: '被保险公司',key: 'insurerCompany',minWidth:280},
                {title: '用工地点',key: 'workUnit',width:120},
				{title: '姓名',key: 'insurerName',width:190},
				{title: '身份证号',key: 'insurerIdNumber',width:190},
			],
			editShow:false,
			editForm:{},
			UploadForm:{
				userId:this.$store.state.common.info.userId
			},
			isPass:false,
			isReplacePass:false,
			editNameShow:false,
			editNameForm:{},
		}
	},
	created () {
		this.addForm.policyEnd = this.$route.query.policyEnd;
		let startDate = this.$route.query.policyBegin;
		let endDate = this.$route.query.policyEnd;
		this.dateOptions = {
			disabledDate(date) {
				if(date &&((date.valueOf() >= Date.parse(startDate + ' 00:00:00'))&&(Date.parse(endDate + ' 00:00:00') >= date.valueOf()))){
					return false
				} else {
					return true
				}
			}
		}
	},
	methods:{
		editNameCancel(){
			this.editNameShow = false;
			this.editNameForm = {};
		},
		confirmeEitName(){
			this.$axios.post("/employment/person/editName.json",{
				...this.editNameForm
			}).then(res=>{
				this.$Message.success('操作成功!');
				this.search();
				this.editNameCancel();
			})
		},
		// 编辑姓名
		toEditName(row){
			this.editNameShow = true;
			this.$nextTick(()=>{
				this.$set(this.editNameForm,'policyPersonId',row.policyPersonId)
				this.$set(this.editNameForm,'insurerName',row.insurerName)
				console.log(row,this.editNameForm,'232323')
			})
		},
		// 批量替换
		replaceClick(){
			this.replaceShow = true;
		},
		replaceCancel(){
			this.replaceShow = false;
			this.replaceForm = {};
			this.isPass = false;
			this.$refs.uploadReplace.handleremove();
		},
		confirmReplace(){
			this.$refs.replaceForm.validate((valid) => {
				if (valid) {
					this.$axios.post("/employment/person/replacePersonBatch.json",{
						...this.replaceForm
					}).then(res=>{
						this.$Message.success('操作成功!');
						this.search();
						this.replaceCancel();
					})
				}
			})
		},
		/*上传成功后获取数据*/
		uploadReplaceSuccess (res) {
			if(res.code==10000000){
				this.$set(this.replaceForm,'replacePersonItems',res.data.replacePersonItems)
				this.$set(this.replaceForm,'certificateNo',res.data.certificateNo)
				this.$set(this.replaceForm,'isPass',res.data.isPass)
				this.$set(this.replaceForm,'policyBegin',res.data.policyBegin)
				this.$set(this.replaceForm,'policyEnd',res.data.policyEnd)
				this.$set(this.replaceForm,'policyId',res.data.policyId)
				this.$set(this.replaceForm,'userId',res.data.userId)
				this.isReplacePass = res.data.isPass;
			} else {
				this.replaceForm.replacePersonItems = [];
				this.isReplacePass = false;
			}
		},
		removeList(fileList){
			this.addForm.personItemList = [];
			this.replaceForm = {};
			this.isPass = false;
			this.isReplacePass = false;
		},
		getPrice(){
			if(!this.addForm.policyBegin||(this.addForm.personItemList&&this.addForm.personItemList.length==0)){
				return
			}
			this.$axios.post("/employment/policy/countFee.json.all",{
				policyId:this.params.id,
				personNumber: this.addForm.personItemList.length,
				policyBegin: this.formatDate(this.addForm.policyBegin, "yyyy-MM-dd"),
				policyEnd: this.addForm.policyEnd,
				isAdd: true,
				personItemList: this.addForm.personItemList
			}).then(res=>{
				if(res.code==10000000){
					this.$set(this.addForm,'policyFee',res.data.policyFee);
					this.isPass = res.data.isPass;
					if(res.data.personItemList&&res.data.personItemList.length>0){
						this.$set(this.addForm,'personItemList',res.data.personItemList);
					}
				} else {
					this.$Message.error(res.msg)
				}
			})
		},
		addCancel(){
			this.addShow = false;
			this.addForm = {
				personItemList:[]
			};
			this.addForm.policyEnd = this.$route.query.policyEnd;
			this.isPass = false;
			this.$refs.upload.handleremove();
		},
		editCancel(){
			this.editShow = false;
			this.editForm = {};
		},
		addClick(){
			this.addShow = true;
		},
		search () {
			this.$refs.table.getList();
		},
		onSelectionChange (val) {
			this.selectedList = val?val.map(item => item.policyPersonId):[];
			console.log(this.selectedList,'0000000000')
		},
		toEdit(row){
			this.editShow = true;
			this.$nextTick(()=>{
				this.editForm = {
					refInsurerIdNumber:row.insurerIdNumber,
					refInsurerName:row.insurerName,
					policyPersonId: row.policyPersonId,
					policyBegin: row.policyBegin
				}
			})
		},
		// 加人确定
		confirmAdd(){
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$axios.post("/employment/person/addPerson.json",{
						...this.addForm,
						policyBegin: this.formatDate(this.addForm.policyBegin, "yyyy-MM-dd"),
						isAdd: true,
						policyId:this.params.id
					}).then(res=>{
						this.$Message.success('操作成功!');
						this.search();
						this.addCancel();
					})
				}
			})
		},
		// 替换
		editconfirm(){
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$axios.post("/employment/person/replacePerson.json",this.editForm).then(res=>{
						this.$Message.success('操作成功!');
						this.search();
						this.editCancel();
					})
				}
			})
		},
		/*上传成功后获取数据*/
		uploadSuccess (res) {
			if(res.code==10000000){
				this.$set(this.addForm,'personItemList',res.data.personItemList)
				this.isPass = res.data.isPass;
				this.getPrice()
			} else {
				this.addForm.personItemList = [];
				this.isPass = false;
			}
		},
		// 批量删除
		deleteClick(){
			this.$Modal.confirm({
				title: '提示',
				content: '是否进行批量删除',
				onOk: () => {
					this.$axios.post("/employment/person/removePerson.json",this.selectedList).then(res=>{
						this.$Message.success('操作成功!');
						this.search();
					})
				}
			});
		}
	}
}
</script>
<style scoped lang="less">
.mb5{
	margin-bottom: 5px;
}
.red{
	color: #FF2525;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/flexibleEmployer/detail/Policy.vue